// DB module format for network sandboxing
export interface NetworkSandboxingModule {
  enabled: boolean;
  analysisMode: AnalysisMode;
  remediationActions: RemediationActions;
  settings: NetworkSandboxingSettings;
  proxy: ProxyConfiguration;
  contentPrefiltering: ContentPrefiltering;
}
export interface RemediationActions {
  defaultAction: RemediationDefaultAction;
}
interface NetworkSandboxingSettings {
  isCloudSandbox: boolean;
  ip: string | null;
  hostname: string | null;
  endpointId: string | null;
  detonationProfile?: DetonationProfile | null;
}
interface ProxyConfiguration {
  enabled: boolean;
  settings: {
    server: string;
    port: number;
    username: string;
    password: string;
  };
}
interface ContentPrefiltering {
  categories: { [key in Category]: CategoryValue };
  excludeExtensions: string[];
  sizeFilter: SizeFilter;
}
export interface SizeFilter {
  enabled: boolean;
  fileMinSizeKB: number;
  fileMaxSizeMB: number;
}
export interface CategoryValue {
  enabled: boolean;
  level: Level;
}

// DB module format for ghostr
export interface GhostrModule {
  enabled: boolean;
  sandboxAnalyzerSettings: GhostrSettings;
  proxy: ProxyConfiguration;
  contentPrefiltering: ContentPrefiltering;
}
interface GhostrSettings {
  ip: string | null;
  hostname: string | null;
  fqdn: string | null;
  endpointId: string | null;
  detonationProfile: DetonationProfile | null;
}

// DB module format for icap
export interface IcapModule {
  enabled: boolean;
  sandboxAnalyzerSettings: IcapSettings;
  proxy: ProxyConfiguration;
  contentPrefiltering: IcapContentPrefiltering;
}
interface IcapContentPrefiltering extends ContentPrefiltering {
  submitFilesMarkedAsMalware: boolean;
}
interface IcapSettings {
  ip: string | null;
  hostname: string | null;
  fqdn: string | null;
  endpointId: string | null;
  detonationProfile: DetonationProfile | null;
}

// DB module format for sandbox manager
export interface SandboxManagerModule {
  dataRetention: number;
  persistSamples: boolean;
}

// local sandboxes
export interface LocalSandbox {
  endpointId: string;
  fqdn: string;
  ip: string;
  name: string;
  port: number;
  protocol: string;
  _id: string;
}

// enums for ui settings
export enum DetonationProfile {
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
}

// enums for content prefiltering
export enum Category {
  APPLICATIONS = 'applications',
  DOCUMENTS = 'documents',
  SCRIPTS = 'scripts',
  ARCHIVES = 'archives',
  EMAILS = 'emails',
}

export enum Level {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}

export enum AnalysisMode {
  MONITORING = 1,
  BLOCKING = 2,
}

export enum RemediationAction {
  REMEDIATE = 0,
  QUARANTINE = 2,
  REPORT_ONLY = 3,
}

export type RemediationDefaultAction = RemediationAction;
